import { Pipe, PipeTransform } from '@angular/core';
import { PlanEnum, PlanOptions } from '../../services/tournament.service';

@Pipe({
    name: 'planType'
})
export class PlanTypePipe implements PipeTransform {

    constructor() { }

    transform(value: number): string {
        if(typeof value == "number"){
            switch(value){
                case 0: return "Jeder gegen Jeden";
                case 1: return "KO-System";
                case 2: return "Vorrunde";
                case 3: return "Vorrunde -> KO-System";
                case 4: return "2 Gruppen -> KO-System";
                case 5: return "2 Gruppen -> KO-System + Platzierungsspiele";
                case 6: return "2 Gruppen -> Platzierungsspiele";
                case 7: return " Gruppen -> Platzierungsspiele";
                case 8: return "Scratch";

            }
        }
        return "";
    }
}
